(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.factory('AppointmentType', ['ContactInfoService', AppointmentTypeFn]);

    // model for appointment-type
    function AppointmentTypeFn(ContactInfoService) {

        var AppointmentType = function () {

            // default values
            this.emailAddress = null;
            this.mobileNumber = null;
            this.mobileNumberPrefix = null;
            this.duration = null;
            this.fK_Agenda = null;
            this.fK_Color = null;
            this.fK_AgendaLabel = null;
            this.agendaLabel = null;
            this.deleted = false;
            this.isVideoConsultType = false;
            this.amountToBePaidUpfront = 0.00;
            this.agendaLabelAppointmentTypes = [];

            //caption list
            this.translations = [];

            // vm 
            this.vmId = null; // random id for tracking -> so DOM is removed if needed

            // extend object
            function extend(type) {
                var self = this;
                angular.extend(self, type);
                // vm id 
                self.vmId = Math.random();
                
                // load emailaddresses
                self.emails = loadContactInfoTypes(3, self.emailAddress, null);
                // load mobilephones
                self.mobileNumbers = loadContactInfoTypes(2, self.mobileNumber, self.mobileNumberPrefix);
            } // extend

            function loadContactInfoTypes(contactInfoTypeId, contactInfoValue, prefix)
            {
                let contactInfoStrings = [];
                let contactInfoTypes = [];
                if (contactInfoValue)
                {
                    contactInfoStrings = contactInfoValue.split(";");
                }

                if (contactInfoStrings.length === 0)
                {
                    contactInfoTypes.push(ContactInfoService.createContactInfoByTypeValue(contactInfoTypeId));
                }else{
                    for (let i = 0; i < contactInfoStrings.length; i++)
                    {
                        let contactInfoType = ContactInfoService.createContactInfoByTypeValue(contactInfoTypeId);
                        contactInfoType.id = i+1;
                        contactInfoType.value = contactInfoStrings[i];
                        if (contactInfoTypeId === 2)
                        {
                            contactInfoType.mobileNumberPrefix = prefix;
                        }
                        contactInfoTypes.push(contactInfoType);
                    }
                }
                return contactInfoTypes;
            }
            // prepare for backend save
            function prepareForSave() {
                let self = this;

                // mail
                self.emailAddress = combineValuesForContactInfoType(self.emails);
                
                // mobile
                self.mobileNumber = combineValuesForContactInfoType(self.mobileNumbers);
                
                for (const aa of self.agendaLabelAppointmentTypes) {
                    aa.agendaLabel = null;
                }

                // prepare translation list
                for (var i = 0; i < self.translations.length; i++) {
                    self.translations[i].prepareForSave();
                    // set required foreign keys
                    self.translations[i].fK_AppointmentType = self.id;
                }

                delete self.color;
                delete self.agendaLabel;
                delete self.agenda;
                delete self.vmId;
            } //prepare

            function combineValuesForContactInfoType(contactInfoTypes) {
                let combinedValue = "";
                if (contactInfoTypes && contactInfoTypes.length > 0)
                {
                    contactInfoTypes.forEach((contactInfoType) =>{
                        if (contactInfoType && contactInfoType.value && contactInfoType.value.length > 0)
                        {
                            if (combinedValue.trim().length > 0)
                            {
                                combinedValue = combinedValue + ";" + contactInfoType.value;
                            }else {
                                combinedValue = contactInfoType.value;
                            }
                        }
                    })
                }
                return combinedValue;
            }

            //public
            this.extend = extend;
            this.prepareForSave = prepareForSave;
        };

        return AppointmentType;
    }
})();